import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { X } from "lucide-react";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";

const TONES = { info: "bg-[#0033FF] text-white", success: "bg-emerald-600 text-white", warning: "bg-amber-400 text-zinc-900" };

export const AnnouncementBanner = () => {
  const { user } = useAuth();
  const [a, setA] = useState(null);
  useEffect(() => {
    if (!user) return;
    api.get("/announcement").then(({ data }) => {
      const x = data.announcement;
      if (x && localStorage.getItem("vc_dismissed_announcement") !== x.id) setA(x);
    }).catch(() => {});
  }, [user]);
  if (!a) return null;
  const dismiss = () => { localStorage.setItem("vc_dismissed_announcement", a.id); setA(null); };
  const ext = a.link_url?.startsWith("http");
  return (
    <div className={`px-4 sm:px-6 lg:px-10 py-2.5 text-sm flex items-center gap-3 ${TONES[a.level] || TONES.info}`} data-testid="announcement-banner">
      <span className="flex-1">{a.message}
        {a.link_url && (ext
          ? <a href={a.link_url} target="_blank" rel="noreferrer" className="ml-2 font-bold underline underline-offset-2" data-testid="announcement-link">{a.link_label || "Learn more"}</a>
          : <Link to={a.link_url} className="ml-2 font-bold underline underline-offset-2" data-testid="announcement-link">{a.link_label || "Learn more"}</Link>)}
      </span>
      <button onClick={dismiss} aria-label="Dismiss" data-testid="announcement-dismiss"><X className="w-4 h-4 opacity-80 hover:opacity-100" /></button>
    </div>
  );
};
